module.exports = __webpack_public_path__ + "ec5edc396112fc95f8639fb2342f3b7f.svg";